import { importLibrary, setOptions } from '@googlemaps/js-api-loader'
import { memo, useEffect, useState } from 'react'
import { useIsMounted } from 'usehooks-ts'

import { env } from '@/config/env'

import {
  GoogleMutantLayerComponent,
  GoogleMutantLayerProps,
} from './leaflet-component'

setOptions({
  key: env.googleApiKey,
  v: 'weekly',
  libraries: ['places'],
  language: 'pt-BR',
})

export const GoogleMutantLayer = memo((props: GoogleMutantLayerProps) => {
  const [isLoaded, setIsLoaded] = useState(false)
  const isMounted = useIsMounted()

  useEffect(() => {
    const loadApi = async () => {
      try {
        await importLibrary('places')
        isMounted() && setIsLoaded(true)
      } catch (error) {
        console.error('Failed to load Google Maps API:', error)
      }
    }

    loadApi()
  }, [])

  if (!isLoaded) return null

  return <GoogleMutantLayerComponent {...props} />
})

GoogleMutantLayer.displayName = 'GoogleMutantLayer'
